/**
 * @generated SignedSource<<9be2ef4467716d2220bf50f5c151f9eb>>
 * @relayHash 34fb74a5e47688b6982a8ddea57578b7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ea7aa8783f92019b89cb80e8e598024ca4ad0b3ffb1025d76d5fb1c0e9bd9a4b

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ConfluenceTrackType = "BRIEFING" | "NARRATION" | "%future added value";
export type ModifyPlaylistButtons_AddToPlaylistButton_Mutation$variables = {
  ari: string;
  cloudId: string;
  top?: boolean | null | undefined;
  type: ConfluenceTrackType;
};
export type ModifyPlaylistButtons_AddToPlaylistButton_Mutation$data = {
  readonly confluence_addTrack: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
    readonly track: {
      readonly id: string;
      readonly mainContent: {
        readonly history: {
          readonly createdBy: {
            readonly displayName: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly id: string | null | undefined;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly value: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly space: {
          readonly key: string | null | undefined;
        } | null | undefined;
        readonly subType: string | null | undefined;
        readonly title: string | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined;
      readonly mainSource: string;
      readonly supportingSources: ReadonlyArray<string> | null | undefined;
      readonly type: ConfluenceTrackType;
    } | null | undefined;
  } | null | undefined;
};
export type ModifyPlaylistButtons_AddToPlaylistButton_Mutation = {
  response: ModifyPlaylistButtons_AddToPlaylistButton_Mutation$data;
  variables: ModifyPlaylistButtons_AddToPlaylistButton_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ari"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "top"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v4 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "top",
        "variableName": "top"
      },
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "mainSource",
            "variableName": "ari"
          },
          {
            "kind": "Variable",
            "name": "trackType",
            "variableName": "type"
          }
        ],
        "kind": "ObjectValue",
        "name": "track"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "success"
},
v6 = {
  "concreteType": "ConfluenceAddTrackPayloadError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    },
    {
      "concreteType": "ConfluenceAddTrackPayloadErrorExtension",
      "kind": "LinkedField",
      "name": "extensions",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "statusCode"
        }
      ]
    }
  ]
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "type"
},
v9 = {
  "kind": "ScalarField",
  "name": "mainSource"
},
v10 = {
  "kind": "ScalarField",
  "name": "supportingSources"
},
v11 = {
  "kind": "ScalarField",
  "name": "title"
},
v12 = {
  "kind": "ScalarField",
  "name": "subType"
},
v13 = {
  "kind": "ScalarField",
  "name": "key"
},
v14 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v15 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "emoji-title-published"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "value"
        }
      ]
    }
  ],
  "storageKey": "properties(keys:[\"emoji-title-published\"])"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ModifyPlaylistButtons_AddToPlaylistButton_Mutation",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "ConfluenceAddTrackPayload",
        "kind": "LinkedField",
        "name": "confluence_addTrack",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "concreteType": "ConfluenceTrack",
            "kind": "LinkedField",
            "name": "track",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "mainContent",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v11/*: any*/),
                  (v8/*: any*/),
                  (v12/*: any*/),
                  {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v15/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ModifyPlaylistButtons_AddToPlaylistButton_Mutation",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "ConfluenceAddTrackPayload",
        "kind": "LinkedField",
        "name": "confluence_addTrack",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "concreteType": "ConfluenceTrack",
            "kind": "LinkedField",
            "name": "track",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "mainContent",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v11/*: any*/),
                  (v8/*: any*/),
                  (v12/*: any*/),
                  {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v7/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__typename"
                          },
                          (v14/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v15/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "ea7aa8783f92019b89cb80e8e598024ca4ad0b3ffb1025d76d5fb1c0e9bd9a4b",
    "metadata": {},
    "name": "ModifyPlaylistButtons_AddToPlaylistButton_Mutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "004acc30984bbb1c77aa9e50f4de41a5";

export default node;
